import script from "./PromptManager.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptManager.vue?vue&type=script&setup=true&lang=js"

import "./PromptManager.vue?vue&type=style&index=0&id=2ed6678c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed6678c"]])

export default __exports__